export default __webpack_public_path__ + "static/media/HelveticaNeueLTW1G-Blk.c0d17c52.ttf";